module.exports = __webpack_public_path__ + "static/img/15.d2d90a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/15.jpg
// module id = yUxe
// module chunks = 1